import React, { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Sidebar from '../Sidebar';
import useIsMobile from '../../useIsMobile';
import SimpleProviders from './SimpleProviders';

/** 공지 등 — 챗봇 사이드바 유지 (관리자 셸과 동일 패턴) */
const ChatbotShell = ({ children }: { children: ReactNode }) => (
  <SimpleProviders>
    <ShellInner>{children}</ShellInner>
  </SimpleProviders>
);

const ShellInner = ({ children }: { children: ReactNode }) => {
  const isMobile = useIsMobile();
  const history = useHistory();

  const handleItemClick = (item: string) => {
    const q = item.trim();
    if (!q) {
      history.push('/');
      return;
    }
    try {
      sessionStorage.setItem('pendingChatQuestion', q);
    } catch {
      /* ignore */
    }
    history.push({ pathname: '/', state: { pendingChatQuestion: q } });
  };

  if (isMobile) {
    return <MobileMain>{children}</MobileMain>;
  }

  return (
    <DesktopShell>
      <Sidebar onItemClick={handleItemClick} isMobile={false} />
      <DesktopMain>{children}</DesktopMain>
    </DesktopShell>
  );
};

export default ChatbotShell;

const DesktopShell = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.bgColor};
  color: ${({ theme }) => theme.textDefaultColor};
`;

const DesktopMain = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: ${({ theme }) => theme.bodyBgColor};
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.borderGrayColor};

  /* 공지 페이지가 메인 패널 전체를 채우도록 */
  & > * {
    flex: 1 0 auto;
    width: 100%;
  }
`;

const MobileMain = styled.div`
  min-height: 100vh;
  width: 100%;
  overflow: auto;
  background: ${({ theme }) => theme.bodyBgColor};
  color: ${({ theme }) => theme.textDefaultColor};
`;
